import { useState } from 'react'
import type { TimelineTech } from '@/shared/api'
import { cn } from '@/shared/lib/cn'
import { Icon } from '@/shared/ui'
import s from './TechGroup.module.css'

/**
 * Свёрнутая группа технических записей ленты (`TimelineTech`): доставка, ретраи, служебные
 * пометки — то, что топит разговор, если показывать построчно. По клику раскрывается в список
 * `items`. Сервер сам решает, что группировать; фронт только сворачивает.
 */
export function TechGroup({ item }: { item: TimelineTech }) {
  const [open, setOpen] = useState(false)

  return (
    <div className={s.root}>
      <button type="button" className={s.head} onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className={s.label}>{item.label}</span>
        {item.timeLabel ? <span className={s.time}>{item.timeLabel}</span> : null}
        <Icon
          name="chevron-down"
          size={12}
          strokeWidth={2}
          className={cn(s.chevron, open && s.chevronOpen)}
        />
      </button>

      {open ? (
        <ul className={s.items}>
          {item.items.map((entry) => (
            <li key={entry.id} className={s.item}>
              <span className={s.itemText}>{entry.text}</span>
              <span className={s.itemTime}>{entry.timeLabel}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
